import { render, staticRenderFns } from "./LolerShow.vue?vue&type=template&id=41527473&scoped=true"
import script from "./LolerShow.vue?vue&type=script&lang=js"
export * from "./LolerShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41527473",
  null
  
)

export default component.exports